import * as XLSX from "xlsx";
import { VendorSummaryDTO } from "../../models/vendors/vendor-model";


export const exportVendorsToExcel = (vendors: VendorSummaryDTO[]): void => {
  if (!vendors || vendors.length === 0) {
    console.warn("⚠️ No vendor data to export");
    return;
  }

  try {
    const exportData = vendors.map((vendor: VendorSummaryDTO) => ({
      "Vendor ID": vendor.vendorID,
      "User Name": vendor.userName,
      "Firm Info": vendor.firmInfo,
      "Office Contact Number": vendor.officeContactNbr || "-",
      "Email": vendor.email || "-",
      "Address": vendor.address || "-",
      "Contact Person 1": vendor.contactPerson1_Name || "-",
      "Contact Number 1": vendor.contactPerson1_Nbr || "-",
      "Contact Person 2": vendor.contactPerson2_Name || "-",
      "Contact Number 2": vendor.contactPerson2_Nbr || "-",
      "Additional Info": vendor.additionalInfo || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vendors");

    // Set column widths for better readability
    const columnWidths = [
      { wch: 12 }, // Vendor ID
      { wch: 20 }, // User Name
      { wch: 25 }, // Firm Info
      { wch: 20 }, // Office Contact Number
      { wch: 25 }, // Email
      { wch: 30 }, // Address
      { wch: 20 }, // Contact Person 1
      { wch: 18 }, // Contact Number 1
      { wch: 20 }, // Contact Person 2
      { wch: 18 }, // Contact Number 2
      { wch: 25 }, // Additional Info
    ];
    worksheet["!cols"] = columnWidths;

    // Style header row
    const headerStyle = {
      fill: { fgColor: { rgb: "4CAF50" } }, 
      font: { bold: true, color: { rgb: "FFFFFF" } }, 
      alignment: { horizontal: "center", vertical: "center" },
    };

    // Apply header styling
    for (let i = 0; i < Object.keys(exportData[0]).length; i++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
      if (worksheet[cellRef]) {
        worksheet[cellRef].s = headerStyle;
      }
    }

    // Generate filename with current date
    const date = new Date();
    const dateString = date.toISOString().split("T")[0];
    const filename = `Vendors_${dateString}.xlsx`;

    // Write file
    XLSX.writeFile(workbook, filename);
    console.log("✅ Export successful! Records exported:", exportData.length);
  } catch (error) {
    console.error("❌ Export error:", error);
    throw error;
  }
};
